import React, { useRef, useState } from 'react'
import Slider from 'react-slick'
import DynamicHeadingTags from 'src/components/common/DynamicHeadingTags/DynamicHeadingTags'
import { HeadingLevel } from 'src/typings/headingTags'
import InsiderProductCardCampaign from './InsiderProductCardCampaign'
import '../styles.scss'
import { useInsiderCampaignLoader } from 'src/hooks/useInsiderCampaignLoader'
import CustomArrow from '../SlickArrows/CustomArrow'
import InsiderShelfSkeleton from '../InsiderSkeleton/InsiderSkeleton'
import useWindowDimensions from 'src/hooks/useWindowDimensions'
import InsiderDots from '../InsiderDots/InsiderDots'

interface Props {
  insiderShelfTitle: string
  headingTitle: HeadingLevel
  campaignId: number
  fontfamily: string
}

const InsiderShelfCampaign: React.FC<Props> = ({
  campaignId,
  insiderShelfTitle,
  headingTitle,
  fontfamily,
}) => {
  const {
    isLoading,
    hasProducts,
    products: sessionProducts,
    variationId,
  } = useInsiderCampaignLoader(String(campaignId), 5000)

  const sliderRef = useRef<Slider>(null)

  const [currentPage, setCurrentPage] = useState(0)
  const { isMobile } = useWindowDimensions()

  if (isLoading) {
    return <InsiderShelfSkeleton />
  }

  if (!hasProducts || !sessionProducts.length) {
    return null
  }

  const idsList = sessionProducts.map((p) => p.item_id).join(',')
  const itemsPerPage = isMobile ? 2 : 4
  const maxVisibleIndicators = 6

  const sliderSettings = {
    arrows: true,
    prevArrow: <CustomArrow direction="prev" />,
    nextArrow: <CustomArrow direction="next" />,
    infinite: true,
    slidesToShow: itemsPerPage,
    slidesToScroll: itemsPerPage,
    afterChange: (firstVisibleIndex: number) => {
      setCurrentPage(Math.floor(firstVisibleIndex / itemsPerPage))
    },
    
    dots: true,
    customPaging: () => <></>,
    appendDots: () => (
      <InsiderDots
        length={sessionProducts.length} 
        currentSlider={currentPage}
        maxVisibleIndicators={maxVisibleIndicators}
        refSlider={sliderRef}
        isMobile={isMobile}
        itemsPerPage={itemsPerPage}
        backgroundDotsActive="#000"
        backgroundDotsInactive="#ccc" 
      />
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        
      },
        {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
        
      },
    ],
  }
  return (
    <section className="insider-shelf ">
      <div className="shelf-header">
        <DynamicHeadingTags
          className="insider-shelf__title"
          as={headingTitle}
          style={{
            fontFamily: fontfamily === '2' ? 'roboto' : 'Cormorant Garamond',
          }}
        >
          {insiderShelfTitle}
        </DynamicHeadingTags>
      </div>
      <div className={`insider-wrapper-${variationId}`}>
        <div
          className="recommender-body"
          data-recommended-items={`[${idsList}]`}
        >
          <Slider ref={sliderRef} {...sliderSettings}>
            {sessionProducts.map((product, idx) => (
              <div
                key={`${product.item_id}-${idx}`}
                className="recommender-box-item"
              >
                <InsiderProductCardCampaign product={product} index={idx} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default InsiderShelfCampaign
